<template>
  <section id="js-scroll" class="invalid-token-section">
    <Alert :lang="lang" :alertText="alertText"></Alert>
    <p class="margin-top25">
      {{ InvalidToken.description[lang] }}&nbsp;{{ eventName }}
    </p>
    <figure class="app-overview">
      <img
        src="../../../assets/images/app/runkeeper-app-logo.png"
        alt=""
        width="40px"
        height="40px"
      />
      <figcaption class="app-name">ASICS Runkeeper™</figcaption>
    </figure>
    <div class="cooperation-button">
      <PrimaryButton type="button" @click.native="reLink">
        {{ InvalidToken.cooperation[lang] }}
      </PrimaryButton>
    </div>
  </section>
</template>

<script>
import Alert from "./Alert";
import PrimaryButton from "./PrimaryButton";
import InvalidToken from "../../../assets/constants/confirmation/invalid-token/invalid-token";
import { RepositoryFactory } from "../../../api/RepositoryFactory";
export default {
  data() {
    return {
      InvalidToken: InvalidToken,
    };
  },
  mounted() {
    // 要素見えない可能性あるのでスクロール入れる
    const element = document.getElementById("js-scroll");
    element.scrollIntoView({ behavior: "smooth" });
  },
  props: {
    email: {
      type: String,
    },
    appauthid: {
      type: String,
    },
    lang: {
      type: String,
    },
    eventId: {
      type: String,
    },
    eventName: {
      type: String,
    },
  },
  methods: {
    reLink: async function () {
      const data = {
        event_id: this.eventId,
        email: this.email,
        app_auth_code: this.appauthid,
        application: "runkeeper",
      };
      try {
        const OauthUserRepository = RepositoryFactory.get("oauth");
        const response = await OauthUserRepository.postRelease(data);
        this.releaseData = response.data;
      } catch (e) {
        console.error(e);
      }
      if (!this.releaseData.count) {
        return;
      }
      const oauthUrl = process.env.RUNKEEPER.OAUTH_URI;
      const clientId = process.env.RUNKEEPER.CLIENT_ID;
      const resType = process.env.RUNKEEPER.RES_TYPE;
      const redirectUrl = process.env.SITE.TMF_REDIRECT_URL;
      location.href = `${oauthUrl}?client_id=${clientId}&response_type=${resType}&redirect_uri=${redirectUrl}?lang=${this.lang}`;
    },
  },
  computed: {
    alertText: function () {
      return "invalid-token";
    },
  },
  components: {
    Alert,
    PrimaryButton,
  },
  name: "InvalidToken",
};
</script>

<style scoped lang="scss">
$pageColor: #000;
.invalid-token-section {
  .app-overview {
    margin: 45px auto 0 auto;
    width: 343px;
    display: flex;
    align-items: center;
    .app-name {
      margin: 0 0 0 10px;
      font-size: 16px;
      font-weight: bold;
    }
  }
  .cooperation-button {
    margin: 12px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/oauth/InvalidToken.vue